export default "__VITE_ASSET__Cl5sTPbL__"